import { render } from "./iconLibros.vue?vue&type=template&id=3014a60b&scoped=true"
import script from "./iconLibros.vue?vue&type=script&lang=js"
export * from "./iconLibros.vue?vue&type=script&lang=js"

import "./iconLibros.vue?vue&type=style&index=0&id=3014a60b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3014a60b"

export default script